// const TruncateString = (text, length = 50) => {
//   let truncatedText = text?.substring(0, length);
//   if (text?.length > length) {
//     truncatedText += "...";
//   }
//   return truncatedText;
// };

// export default TruncateString;

const TruncateString = (text, length = 50) => {
  try {
    if (!text) return "";

    if (text.length <= length) return text;
  } catch (error) {
    console.error("Error in TruncateString:", error);
    return ""; // Return empty string if there's an error
  }

  return text.substring(0, length) + "...";
};

export default TruncateString;
